export const isObjectEquals = (a, b) => JSON.stringify(a) === JSON.stringify(b);
export const cloneObject = (object) => JSON.parse(JSON.stringify(object));
export const hasProperty = (object, key) => {
  if (!object) {
    return undefined;
  }

  const parts = key.split('.');

  if (parts.length === 1) {
    return Object.prototype.hasOwnProperty.call(object, parts[0]);
  }

  const property = parts.shift();

  return hasProperty(object[property], parts.join('.'));
};

export const getProperty = (object, key) => {
  if (!object) {
    return undefined;
  }

  const parts = key.split('.');

  if (parts.length === 1) {
    return object[parts[0]];
  }

  const property = parts.shift();

  return getProperty(object[property], parts.join('.'));
};

export const merge = (a, b) => {
  Object.keys(b)
    .filter((key) => hasProperty(a, key))
    .forEach((key) => {
      if (Array.isArray(b[key]) || b[key] === null || typeof b[key] !== 'object') {
        a[key] = b[key];
      } else if (typeof b[key] === 'object') {
        merge(a[key], b[key]);
      }
    });
  return a;
};
